import React, { Fragment, useState } from 'react';
import {translate} from 'react-i18next';
import {Button, Icon, Input} from 'antd';
import { getMappingExpression, mappingTypeDefault, mappingTypeFixed } from '../../scenes/data-manager/file-mapping/wizard/utils';
import { MARGIN_MD, MARGIN_SM, MODAL_WIDTH_LG } from '../../styles/constants';
import { getArtefactTripletFromString } from '../../utils/sdmxJson';
import {DataLanguageConsumer} from "../../contexts/DataLanguage";
import EnhancedModal from "../enhanced-modal";
import ItemList from "../item-list";

const FileMappingComponentList = ({
                                    t,
                                    appLanguage,
                                    mappings,
                                    selectedMapping,
                                    onSelect,
                                    columnNameKey,
                                    cubeComponentCodeKey,
                                    editFixedComponent,
                                    cube,
                                    fetchCodelistCodesItemsPage,
                                    componentCodelistCodesItemsPage,
                                    componentCodelistCodesItemsCount,
                                    onModifyMappingFixedValue,                 
                                  }) => {

const mappingIsSelected = (mapping, selectedMapping) => {
  return mapping && selectedMapping && 
        mapping.ColumnName === selectedMapping.ColumnName && 
        mapping.CubeComponentCode === selectedMapping.CubeComponentCode;
}

const defaultMappings = (mappings || []).filter(m => m.MappingType === mappingTypeDefault);
const nonDefaultMappings = (mappings || []).filter(m => m.MappingType !== mappingTypeDefault);

const divComponentsStyle = {
  overflow: "auto",
  height: "100%",
  border: "1px solid #e8e8e8",
  paddingLeft: 4,
  paddingRight: 4
}

const divComponentStyle =  {
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: 8,
    paddingRight: 8,
    minWidth: 120,        
}


const [isFixedValueModifierVisible, setFixedValueModifierVisible] = useState(false);
const [codelistTriplet, setCodelistTriplet] = useState(false);
const [componentName, setComponentName] = useState(null);
const [inputFixedValue, setInputFixedValue] = useState(null);

const showValueModifier = (componentName) => {
  setComponentName(componentName);
  const component = [...cube.Attributes, ...cube.Dimensions].find(c => c.Code === componentName);
  if (component.CodelistCode) {
    setCodelistTriplet(getArtefactTripletFromString(component.CodelistCode));        
  } else {
    setCodelistTriplet(null);    
  }    
  setInputFixedValue(null);
  setFixedValueModifierVisible(true);
}

const onFixedComponentValueSet = (value) => {
  onModifyMappingFixedValue(componentName,value);                     
  setFixedValueModifierVisible(false);  
}
  return (
    <Fragment>
      
      <div>                                  
        
        <div style={divComponentsStyle}>
          {
            defaultMappings.map((mapping, index) =>
              <div
                key={index}
                onClick={() => onSelect ? onSelect(mapping) : null}
                title={onSelect
                  ? t("commons.actions.select.title") + ' ' + mapping.ColumnName + ' - ' + mapping.CubeComponentCode
                  : null
                }
                style={{
                  ...divComponentStyle,
                  cursor: onSelect ? "pointer" : "cursor",
                  background: mappingIsSelected(mapping, selectedMapping)
                    ? "#ffafa3"
                    : (index % 2)
                      ? "#f5f5f5"
                      : "#ffffff",
                }}
              >
                <div
                  style={{
                    width: "calc(50% - 24px)",
                    verticalAlign: "middle",
                    display: "inline-block",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  }}
                >
                  {mapping.ColumnAlias !== null ? mapping.ColumnAlias : mapping[columnNameKey]}
                </div>
                <Icon
                  type="link"
                  style={{
                    width: 32,
                    marginLeft: 8,
                    marginRight: 8,
                    verticalAlign: "middle",
                    display: "inline-block"
                  }}
                />
                <div
                  style={{
                    width: "calc(50% - 24px)",
                    verticalAlign: "middle",
                    display: "inline-block",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  }}
                >
                  {mapping[cubeComponentCodeKey]}
                </div>
              </div>
            )          
          }
        </div>

        {
          nonDefaultMappings.length > 0 && (
            <Fragment>
              <div
                style={{fontWeight:"bold", marginTop:MARGIN_MD, marginBottom:MARGIN_SM}}
              >
                {t('scenes.dataManager.fileMapping.wizard.componentList.componentsWithValue.title')}
              </div>

              <div style={divComponentsStyle}>            
                {
                  nonDefaultMappings.map((mapping, index) => 
                    {
                      const mappingExpression = getMappingExpression(mapping);
                      return (
                        <div
                          key={`vAss_${index}`}
                            onClick={() => onSelect ? onSelect(mapping) : null}
                            style={{
                              ...divComponentStyle,
                              cursor: onSelect ? "pointer" : "cursor",
                              background: mappingIsSelected(mapping, selectedMapping)
                                ? "#ffafa3"
                                : (index % 2)
                                  ? "#f5f5f5"
                                  : "#ffffff"
                            }}
                          >
                            <span
                              style={{
                                width: "calc(100% - 32px)",
                                verticalAlign: "middle",
                                display: "inline-block",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",                        
                              }}
                              title={mappingExpression}
                            >
                              <b>{mapping.CubeComponentCode}</b>={mappingExpression}
                            </span>
                            {
                              editFixedComponent && mapping.MappingType === mappingTypeFixed
                              ? (
                                <Icon                                                        
                                  style={{
                                    width: 16,
                                    marginLeft: 8,
                                    verticalAlign: "middle",
                                    display: "inline-block",
                                    cursor: "pointer"
                                  }}
                                  onClick={() => showValueModifier(mapping.CubeComponentCode)}
                                  type="edit"
                                  title={t('scenes.dataManager.fileMapping.wizard.componentList.editFixedComponent.title')}
                                />
                              )
                              : null
                            }
                        </div>
                      )
                    }                                              
                   ) 
                }
              </div>
            </Fragment>
          )
        }
      </div>

      <EnhancedModal
        visible={isFixedValueModifierVisible}
        onCancel={() => setFixedValueModifierVisible(false)}
        title={codelistTriplet 
          ? t('scenes.dataManager.fileMapping.wizard.cards.cubeComponents.cubeComponentList.editFixedComponent.selector.title')
          : t('scenes.dataManager.fileMapping.wizard.cards.cubeComponents.cubeComponentList.editFixedComponent.input.title')}
        width={MODAL_WIDTH_LG} 
        footer={codelistTriplet 
          ? null
          : <div>
              <Button
                onClick={() => onFixedComponentValueSet(inputFixedValue)}
                type="primary"
                disabled={(inputFixedValue || "").length === 0}
              >
                {t('commons.buttons.confirm.title')}
              </Button>
          </div>
        }               
      >
        <DataLanguageConsumer>   
          {dataLanguage => {
            const language = dataLanguage || appLanguage;
            return (
              codelistTriplet
                ? <ItemList
                    data={componentCodelistCodesItemsPage || null}
                    rowCount={componentCodelistCodesItemsCount}
                    isPaginated
                    onRowClick={item => onFixedComponentValueSet(item.id)}      
                    onChange={
                      ({pageNum, pageSize, searchText, filters, sortCol, sortByDesc}) =>
                      fetchCodelistCodesItemsPage({
                          codelistTriplet,
                          language,
                          pageNum,
                          pageSize,
                          searchText,
                          filters,
                          sortCol,
                          sortByDesc,
                          componentName
                        })
                    }
                  /> 
                : <Input 
                    onChange={({target}) => setInputFixedValue(target.value)}
                    value={inputFixedValue}
                  /> 
            )             
          }}     
        </DataLanguageConsumer>
      </EnhancedModal>

    </Fragment>
  );                                    
}
  

export default translate()(FileMappingComponentList);
